module.exports = __webpack_public_path__ + "img/wx.829a9711.png";